import { Grid, Skeleton } from '@mui/material';
import { getWeekdayMonthAndYear } from '@nx-smartmonkey/shared/helpers';
import { RoutalPalette } from '@nx-smartmonkey/ui';

import { useRetrieveUser } from '../../../../hooks/user/useRetrieveUser';
import Text from '../../../../react-components/Text';

export const HEADER_HEIGHT = 55;

interface PlannerPlansDayHeaderProps {
  selectedDay?: Date;
}

export const PlannerPlansDayHeader = ({ selectedDay }: PlannerPlansDayHeaderProps) => {
  const { data: user } = useRetrieveUser();

  return (
    <Grid
      container
      direction="row"
      wrap="nowrap"
      alignItems="center"
      style={{ height: `${HEADER_HEIGHT}px`, padding: `0 16px`, borderBottom: `1px solid ${RoutalPalette.neutral10}` }}
    >
      {selectedDay ? (
        <Text variant="body-large" style={{ color: RoutalPalette.primary80 }}>
          {getWeekdayMonthAndYear({
            date: selectedDay,
            language: user?.language.value,
          })}
        </Text>
      ) : (
        <Skeleton variant="rectangular" animation="pulse" height={22} width={155} /> // just eyeballing the width and height using a normal day as example
      )}
    </Grid>
  );
};
